import { render, staticRenderFns } from "./ChargementBpij.vue?vue&type=template&id=6252e104&scoped=true"
import script from "./ChargementBpij.vue?vue&type=script&lang=js"
export * from "./ChargementBpij.vue?vue&type=script&lang=js"
import style0 from "./ChargementBpij.vue?vue&type=style&index=0&id=6252e104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6252e104",
  null
  
)

export default component.exports